const PackageOrderKeys = {
  INTERVIEWS_WITH_WORDS: 'extraInterviewWithWords',
  WORDS: 'extraWords',
  PHOTOS: 'extraPhotos',
  REVISIONS: 'extraRevisions',
  HARDBACK_COPIES: 'extraHardbackCopies',
  PAPERBACK_COPIES: 'extraPaperbackCopies',
  STORYTELLER: 'extraStoryteller',
  CUSTOM_DESIGN: 'customDesign',
  CUSTOM_COVER: 'customCover',
  COMMERCIAL_COVER: 'commercialCover',
  FAMILY_TREE: 'familyTree',
  AMAZON_FOR_YOU: 'amazonForYou',
  AMAZON_PROMOTION: 'amazonPromotion',
  MULTIPLATFORM: 'multiplatform',
  EXTENSION_FEE: 'extensionFee',
  CUSTOM_REQUEST: 'customRequest',
  DEVELOPMENTAL_EDIT: 'developmentalEdit',
  PREMIUM_PROOFREAD: 'premiumProofread',
  WRITER_CONSULTATION: 'writerConsultation',
  PROFESSIONAL_EDIT: 'professionalEdit',
};

export default PackageOrderKeys;
